module.exports = __webpack_public_path__ + "img/2.e6a83254.png";